import Vue from 'vue'
// import * as PvcamApi from  "@/services/API.js"
import {
    GetOrgTree,
    MoveOrgNode,
    CreateOrgNode,
    DeleteOrgNode,
    GetOrgVehicles,
    ListOrgUsers,
    AssignUserToNode,
    AssignVehicleToNode,
    ListAllRoles,
    CreatePendingInvite,
    ListVehicleTypes,
    CreateOrgVehicle,
    ListOrgInvites,
    UpdateOrgVehicle,
    GetOrgDeviceInfo,
    GetOrgAlertsConfig,
    GetVehicleAlertsConfig,
    GetAutoUploadSetting,
    UpdateVehicleAlertsConfig,
    CreateAlertNotification,
    UpdateAutoUploadSettings,
    CreateEmailAlert,
    GetContacts
} from '@/services/API.js'

const NodeApi = {
    install: Vue => {
        Vue.prototype.$NodeApi = {
            GetOrgTree,
            MoveOrgNode,
            CreateOrgNode,
            DeleteOrgNode,
            GetOrgVehicles,
            ListOrgUsers,
            AssignUserToNode,
            AssignVehicleToNode,
            ListAllRoles,
            CreatePendingInvite,
            ListVehicleTypes,
            CreateOrgVehicle,
            ListOrgInvites,
            UpdateOrgVehicle,
            GetOrgDeviceInfo,
            GetOrgAlertsConfig,
            GetVehicleAlertsConfig,
            GetAutoUploadSetting,
            UpdateVehicleAlertsConfig,
            CreateAlertNotification,
            UpdateAutoUploadSettings,
            CreateEmailAlert,
            GetContacts
        }
    }
}

Vue.use(NodeApi)
